import {
  organizationGetOptions,
  organizationQueryOptions,
  organizationSaveMutation,
} from '@quoruum/frontend-common/oas/gen/admin/@tanstack/react-query.gen';
import { organizationLimitSchema } from './organizationLimit';
import { organizationUserSchema } from './organizationUser';
import { defineEntitySchema, defineRelatedList } from './base/EntitySchema';

export const organizationSchema = defineEntitySchema({
  name: 'organization',
  label: 'Organization',
  idField: 'id',
  primaryText: 'label',
  secondaryText: 'name',
  endpoints: {
    query: organizationQueryOptions,
    read: organizationGetOptions,
    edit: {
      mutation: organizationSaveMutation,
      toRequest: (id, body) => ({ path: { id }, body }),
    },
  },
  relatedLists: [
    defineRelatedList({
      label: 'Limits',
      entity: organizationLimitSchema,
      setParentId: (id) => ({ query: { ids: [id] } }),
      fields: [
        { key: 'type', label: 'Limit' },
        { key: 'value', label: 'Value' },
      ],
    }),
    defineRelatedList({
      label: 'Users',
      entity: organizationUserSchema,
      setParentId: (id) => ({ query: { parentIds: [id] } }),
      // Memberships are not entities of their own; each row links to its user.
      link: { entity: 'user', getId: (item) => item.user.id },
      fields: [
        { key: 'user.name', label: 'User' },
        { key: 'first', label: 'First Name' },
        { key: 'last', label: 'Last Name' },
        { key: 'role', label: 'Role' },
      ],
    }),
  ],
  fields: [
    { key: 'id', label: 'ID', type: 'string', readOnly: true },
    { key: 'name', label: 'Name', type: 'string', readOnly: true },
    {
      key: 'label',
      label: 'Label',
      type: 'string',
      convertValue: (value) => ({ label: typeof value === 'string' ? value : '' }),
    },
    {
      key: 'status',
      label: 'Status',
      type: 'enum',
      options: ['INACTIVE'],
      convertValue: (value) => {
        if (value !== 'INACTIVE') throw new Error('Status can only be set to INACTIVE.');
        return { status: 'INACTIVE' as const };
      },
    },
    { key: 'type', label: 'Type', type: 'enum', options: ['QUORUUM'], readOnly: true },
    { key: 'createdByEmail', label: 'Created By', type: 'string', readOnly: true },
    { key: 'auditBean.created', label: 'Created', type: 'datetime', readOnly: true },
    { key: 'auditBean.timestamp', label: 'Last Modified', type: 'datetime', readOnly: true },
    { key: 'auditBean.modifiedBy', label: 'Modified By', type: 'string', readOnly: true },
  ],
});
